export enum SuggestionTypeEnum {
  Issuer = "Issuer",
  Security = "Security",
  Programme = "Programme",
  Index = "Index",
  Page = "Page"
}
